/**
 * Platform-wide login gate (separate from the site's custom `login` component).
 * Viewer loads this first when Login Required is enabled.
 */

export const GLOBAL_LOGIN_COMPONENT_NAME = 'gg-global-login'

export const LOGIN_COMPONENT_TEMPLATE = `
<div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; background: #f3f4f6; box-sizing: border-box;">
  <div style="width: 100%; max-width: 400px; background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; box-shadow: 0 10px 25px rgba(0,0,0,0.08); padding: 32px; box-sizing: border-box;">
    <h1 style="margin: 0 0 4px; font-size: 20px; font-weight: 600; color: #1f2937; text-align: center;">Site sign in</h1>
    <p style="margin: 0 0 24px; font-size: 14px; color: #6b7280; text-align: center;">Global authentication (required)</p>
    <form @submit.prevent="handleSubmit">
      <div style="margin-bottom: 16px;">
        <label for="gg-login-email" style="display: block; margin-bottom: 8px; font-size: 14px; font-weight: 500; color: #374151;">Email</label>
        <input
          id="gg-login-email"
          type="email"
          v-model="email"
          placeholder="Enter your email"
          autocomplete="email"
          style="width: 100%; padding: 12px 16px; font-size: 14px; border: 1px solid #d1d5db; border-radius: 8px; background: #f9fafb; color: #374151; box-sizing: border-box; outline: none;"
        />
      </div>
      <div style="margin-bottom: 16px;">
        <label for="gg-login-password" style="display: block; margin-bottom: 8px; font-size: 14px; font-weight: 500; color: #374151;">Password</label>
        <div style="position: relative;">
          <input
            id="gg-login-password"
            :type="showPassword ? 'text' : 'password'"
            v-model="password"
            placeholder="Enter your password"
            autocomplete="current-password"
            style="width: 100%; padding: 12px 56px 12px 16px; font-size: 14px; border: 1px solid #d1d5db; border-radius: 8px; background: #f9fafb; color: #374151; box-sizing: border-box; outline: none;"
          />
          <button
            type="button"
            @click="togglePasswordVisibility"
            aria-label="Toggle password visibility"
            style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); border: none; background: transparent; color: #6b7280; cursor: pointer; font-size: 13px; padding: 4px;"
          >
            {{ showPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
      </div>
      <div v-if="error" style="margin-bottom: 16px; padding: 12px; border-radius: 8px; background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; font-size: 14px; text-align: left;">{{ error }}</div>
      <button
        type="submit"
        :disabled="isSubmitting"
        style="width: 100%; margin-top: 8px; background: #00aeef; color: #fff; font-weight: 600; padding: 12px 16px; font-size: 16px; border: none; border-radius: 8px; cursor: pointer; box-shadow: 0 4px 6px rgba(0,0,0,0.1);"
      >
        {{ isSubmitting ? 'Signing in...' : 'Sign in' }}
      </button>
    </form>
  </div>
</div>
`.trim()

export function buildDefaultGlobalLoginComponent() {
  return {
    name: GLOBAL_LOGIN_COMPONENT_NAME,
    template: LOGIN_COMPONENT_TEMPLATE,
    props: [],
    data: [
      { key: 'email', value: '' },
      { key: 'password', value: '' },
      { key: 'showPassword', value: false },
      { key: 'error', value: '' },
      { key: 'isSubmitting', value: false },
    ],
    methods: [
      {
        name: 'handleSubmit()',
        body: `if (!this.email || !this.password) {
  this.error = 'Please enter your email and password.';
  return;
}
this.error = '';
this.isSubmitting = true;
this.$emit('submit', { email: this.email, password: this.password });`,
      },
      {
        name: 'togglePasswordVisibility()',
        body: 'this.showPassword = !this.showPassword;',
      },
    ],
    computed: [],
    watch: [],
    deps: [],
    is_global: true,
  }
}
